export default __webpack_public_path__ + "static/media/gefion1.ad071719.jpeg";